export default __webpack_public_path__ + "static/media/haj4.998bcdcb.jpg";